// DEPENDENCIES ---------------------------------------------------------------- //

import React from 'react';

import { css } from '@emotion/css';
import { useTheme, Theme, TablePagination } from '@mui/material';

// TYPES ---------------------------------------------------------------- //

interface SearchResultsPaginationProps {
  moveCount: number;
  offset: number;
  limit: number;
  setOffset: (offset: number) => void;
  setLimit: (limit: number) => void;
}

// COMPONENT ---------------------------------------------------------------- //

const SearchResultsPagination = ({ moveCount, offset, limit, setOffset, setLimit }: SearchResultsPaginationProps) => {
  const theme = useTheme();
  const cls = useStyles(theme);

  // Calculate current page from offset
  const page = Math.floor(offset / limit);

  // Handle page change
  const handleChangePage = (_event: unknown, newPage: number) => {
    setOffset(newPage * limit);
  };

  // Handle rows per page change
  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newLimit = parseInt(event.target.value, 10);
    setLimit(newLimit);
    setOffset(0); // Reset to first page when changing the number of rows per page
  };

  return (
    <TablePagination
      className={cls.pagination}
      component='div'
      count={moveCount}
      page={page}
      onPageChange={handleChangePage}
      rowsPerPage={limit}
      onRowsPerPageChange={handleChangeRowsPerPage}
      rowsPerPageOptions={[25, 50, 100]}
    />
  );
};

// STYLES ---------------------------------------------------------------- //

const useStyles = (theme: Theme) => ({
  pagination: css`
    border-bottom: 1px solid ${theme.palette.divider};
    margin-right: 16px;
  `,
});

// EXPORT ---------------------------------------------------------------- //

export default SearchResultsPagination;
